import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'naturezaVendaNome'
})
/** Pipe utilizado para exibir o nome da natureza de venda */
export class NaturezaVendaNomePipe implements PipeTransform {

    /** Retorna o nome da natureza de venda */
    transform(nome: string, codigoIntegracaoErp: string = null): string {
        let codigo = '';
        if (codigoIntegracaoErp) {
            codigo = `${codigoIntegracaoErp} - `;
        }
        return `${codigo}${nome}`;
    }
}
